import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@fikasio/react-ui-components';
import { usePatchUserMeMutation } from 'services/login/api';
import { useAuth } from 'services/login/hooks';
import { setLanguage } from 'utils/translation';
import TimeZoneSelector from './TimeZoneSelector';

const SettingsGeneral = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const { user } = auth;
  const { language } = user ?? {};
  const savedTimeZone = user?.timezone ?? '';
  const [timeZone, setTimeZone] = useState(savedTimeZone);
  const [appliedTimeZone, setAppliedTimeZone] = useState(savedTimeZone);
  if (savedTimeZone !== appliedTimeZone) {
    setAppliedTimeZone(savedTimeZone);
    setTimeZone(savedTimeZone);
  }
  const [patchUserMe] = usePatchUserMeMutation();

  const handleChangeLanguage = newLanguage => {
    patchUserMe({
      language: newLanguage,
    })
      .then(({ data }) => {
        if (data) {
          setLanguage(data.language);
        }
      });
  };

  const handleChangeTimeZone = async (next: string) => {
    setTimeZone(next);
    const result = await patchUserMe({
      timezone: next || null,
    });
    if ('error' in result) {
      setTimeZone(savedTimeZone);
    }
  };

  return (
    <div>
      <label className="form-label">{t('language')}</label>
      <br />
      <Select
        defaultValue={language}
        onChange={value => handleChangeLanguage(value)}
        options={[
          { label: 'English', value: 'en' },
          { label: 'Français', value: 'fr' },
        ]}
      />
      <div style={{ marginTop: 16 }}>
        <label className="form-label">{t('timeZone')}</label>
        <br />
        <TimeZoneSelector
          onChange={handleChangeTimeZone}
          value={timeZone}
        />
      </div>
    </div>
  );
};

export default SettingsGeneral;
